import {useQuery} from "@tanstack/react-query";
import {getAppConfigApi} from "../api";
import {isSuccess} from "../api/request";

export default function useAppConfig(){
    const query = useQuery({
        queryKey: ['appConfig'],
        queryFn: async () => {
            const res = await getAppConfigApi()
            if(!isSuccess(res)){
                return null
            }
            return res.data
        },
    })

    return {
        isFetched: query.isFetched,
        isLoading: query.isLoading,
        ...query.data
    }
}